module.exports = __webpack_public_path__ + "img/logo-guru.5f925c9b.png";